import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { EditarticolosearchPage } from "../editarticolosearch/editarticolosearch";
import { SERVER_URL } from "../../config";

/**
 * Generated class for the RicercaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ricerca',
  templateUrl: 'ricerca.html',
})
export class RicercaPage {
  public searchTerm;
  public numResult;
  articoli: string[];
  errorMessage: string;
  link;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider

  ) {
    this.link = SERVER_URL + "/manifesti/files/"

    this.searchTerm=navParams.get('searchTerm');
    if(this.searchTerm!=null){
     this.setFilteredItems();
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RicercaPage');
    
  }
  setFilteredItems() {
    console.log(this.searchTerm);
    if (this.searchTerm.length > 2) {
      this.rest.searcArticoli(this.searchTerm).subscribe(
        articoli => this.articoli = articoli,
        error => this.errorMessage = <any>error);
      if (this.articoli != null) {
      this.numResult = Object.keys(this.articoli).length;
        this.LoadData();
      }
    }
  }
  public LoadData() {
    console.log("LoadData this.articoli:" + JSON.stringify(this.articoli));

    console.log("LoadData");

  }
  openEditarticoloPage(articolo) {

    this.navCtrl.push(EditarticolosearchPage, { articolo: articolo ,searchTerm:this.searchTerm});


  }
}



// WEBPACK FOOTER //
// ./src/pages/ricerca/ricerca.ts